import React, { Fragment, useEffect } from "react";
import MetaTags from "react-meta-tags";

import Loading from "../blocks/loading/Loading";
import Header from "../blocks/header/Header";
import Footer from "../blocks/footer/Footer";

import PageTitleContacts from "../blocks/page-title/PageTitleContacts";
import ContactForm from "../components/form/ContactForm";

import GoogleMaps from "../blocks/google-maps/GoogleMaps";
import ContactsInside from "../blocks/contacts/Contacts";

const Contacts = () => {
  document.body.classList.add("page");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <MetaTags>
        <meta charSet="UTF-8" />
        <title>
          Contacts | Julie Bengueddach - Esthéticienne professionelle
        </title>

        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        <meta name="google-site-verification" content="-sL3qrR8XuJRi2vK6gvyph3PkILJ22ISSOo35kEVpXo" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1,user-scalable=no"
        />
        <meta
          name="description"
          content="Contactez Julie Bengueddach, esthéticienne professionnelle à Igny, pour prendre rendez-vous ou pour toute question. Retrouvez toutes les informations de contact de son institut sur cette page."
        />
        <meta
          name="keywords"
          content="contact, esthéticienne, Igny, rendez-vous, informations de contact, message"
        />
        <meta name="robots" content="index, follow, noodp" />
        <meta name="googlebot" content="index, follow" />
        <meta name="google" content="notranslate" />
        <meta name="format-detection" content="telephone=no" />
      </MetaTags>

      <Loading />

      <Header logoColor="light" />

      <main id="main" className="site-main">
        <PageTitleContacts />
        <div id="page-content" className="spacer p-top-xl">
          <div className="wrapper">
            <div className="content">
              <div className="clearfix">
                <GoogleMaps />

                <div className="spacer p-top-xl">
                  <div className="title">
                    <h2>Parlons-en maintenant</h2>
                  </div>

                  <div className="row gutter-width-sm with-pb-xl spacer p-top-lg">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                      <ContactsInside />
                    </div>

                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
                      <div className="contact-form-shortcode">
                        <ContactForm />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </Fragment>
  );
};

export default Contacts;
